const defaultFields = [
  // {
  //   key: 'commands',
  //   sortable: false,
  // },
  {
    key: 'number',
    label: 'Number',
    tdClass: 'txt-link',
  },
  {
    key: 'companyName',
    label: 'Company',
  },
  {
    key: 'companyRolesAsText',
    label: 'Roles',
  },
  {
    key: 'physicalCity',
    label: 'City',
  },
  {
    key: 'physicalState',
    label: 'State',
  },
  {
    key: 'fax',
    label: 'Fax',
  },
  {
    key: 'website',
    label: 'Website',
  },
  {
    key: 'channelName',
    label: 'Channel',
  },
  {
    key: 'companyStatus',
    label: 'Status',
  },
  {
    key: 'isVerified',
    label: 'Verified',
  }

]

export default defaultFields;
